import { combineReducers } from 'redux';
import { GLOBAL_STYLES_FETCH } from 'ContentData/actions/ActionTypes';
import { PENDING, SUCCEEDED, FAILED, UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
const fields = (state = [], {
  type,
  response,
  error
}) => {
  var _response$fields;
  switch (type) {
    case GLOBAL_STYLES_FETCH:
      if (error) return [];
      return (_response$fields = response === null || response === void 0 ? void 0 : response.fields) !== null && _response$fields !== void 0 ? _response$fields : state;
    default:
      return state;
  }
};
const overrides = (state = {}, {
  type,
  response,
  error
}) => {
  var _response$overrides;
  switch (type) {
    case GLOBAL_STYLES_FETCH:
      if (error) return {};
      return (_response$overrides = response === null || response === void 0 ? void 0 : response.overrides) !== null && _response$overrides !== void 0 ? _response$overrides : state;
    default:
      return state;
  }
};
const requestStatus = (state = UNINITIALIZED, {
  type,
  response,
  error
}) => {
  switch (type) {
    case GLOBAL_STYLES_FETCH:
      {
        if (response) return SUCCEEDED;
        if (error) return FAILED;
        return PENDING;
      }
    default:
      return state;
  }
};
export default combineReducers({
  fields,
  overrides,
  requestStatus
});